export const addToLeaderBoard = (id, name, score) => {
    const leaderBoard = JSON.parse(localStorage.getItem('leaderBoard'));
    console.log("LeaderBoard called");
    leaderBoard.push({ id, name, score });
    leaderBoard.sort((first, second) => second.score - first.score);
    localStorage.setItem('leaderBoard', JSON.stringify(leaderBoard));
}